module.exports = __webpack_public_path__ + "static/img/profession-bg.d896b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all-versions/profession-bg.png
// module id = 894
// module chunks = 2